export * from './platform/default/features.selectors';

export const getAdFeature = ({ features }) => features.adFeature;

export const getAnimateFeature = ({ features }) => features.animateFeature;

export const getAsyncPlayerChunkFeature = ({ features }) => features.asyncPlayerChunk;

export const getBffSearchFeature = ({ features }) => features.bffSearchFeature;

export const getBookmarksFeature = ({ features }) => features.bookmarksFeature;

export const getBroadcastLiveFeature = ({ features }) => features.broadcastLiveFeature;

export const getCustomizerFeature = ({ features }) => features.customizerFeature;

export const getCheckGeoFeature = ({ features }) => features.checkGeoFeature;

export const getContentAdvisorFeature = ({ features }) => features.contentAdvisorFeature;

export const getDisplayLostConnectionFeature = ({ features }) => features.displayLostConnectionFeature;

export const getGdprNoticeFeature = ({ features }) => features.gdprNoticeFeature;

export const getKidsSectionFeature = ({ features }) => features.kidsSectionFeature;

export const getKidsSectionLeaveFeature = ({ features }) => features.kidsSectionLeaveFeature;

export const getLiveSeekFeature = ({ features }) => features.liveSeekFeature;

export const getMenuPopupFeature = ({ features }) => features.menuPopupFeature;

export const getMultiAudioFeature = ({ features }) => features.multiAudioFeature;

export const getMultiProfileFeature = ({ features }) => features.multiprofile;

export const getMultiProfilesGateAlwaysDisplayed = ({ features }) => features.multiProfilesGateAlwaysDisplayed;

export const getMultiSubtitlesFeature = ({ features }) => features.multiSubtitlesFeature;

export const getOpenCatalogFeature = ({ features }) => features.openCatalogFeature;

export const getPairingFeature = ({ features }) => features.pairingFeature;

export const getParentalFilterFeature = ({ features }) => features.parentalFilterFeature;

export const getPlayerAdFeature = ({ features }) => features.player_adFeature;

export const getPlayerAnalyticsFeature = ({ features }) => features.player_analyticsFeature;

export const getPlayerJingleFeature = ({ features }) => features.player_jingleFeature;

export const getPlayerLongSeekFeature = ({ features }) => features.player_longSeek;

export const getPlayerNextVideoFeature = ({ features }) => features.player_nextVideoFeature;

export const getPlayerRelatedVideosFeature = ({ features }) => features.player_relatedVideosFeature;

export const getPlayerReturnFeature = ({ features }) => features.player_returnFeature;

export const getPlayerThirdPartiesFeature = ({ features }) => features.player_thirdPartiesFeature;

export const getPlayerTimeShiftingFeature = ({ features }) => features.player_timeShiftingFeature;

export const getPlayerAdsCountFeature = ({ features }) => features.player_adsCount;

export const getPlayerLBannerFeature = ({ features }) => features.player_lBanner;

export const getPlayerTrackPreferencesFeature = ({ features }) => features.player_trackPreferencesFeature;

export const getPlayerPauseAdFeature = ({ features }) => features.player_pauseAd;

export const getPlayerPauseAdVastFeature = ({ features }) => features.player_pauseAdVast;

export const getPremiumFeature = ({ features }) => features.premiumFeature;

export const getPrivilegeNavigationFeature = ({ features }) => features.privilegeNavigationFeature;

export const getReplayFeature = ({ features }) => features.replayFeature;

export const getScreensaverFeature = ({ features }) => features.screensaverFeature;

export const getSearchFeature = ({ features }) => features.searchFeature;

export const getServicePageFeature = ({ features }) => features.servicePageFeature;

export const getSplashScreenFeature = ({ features }) => features.splashScreenFeature;

export const getStartoverFeature = ({ features }) => features.startoverFeature;

export const getStartoverPopupFeature = ({ features }) => features.startoverPopupFeature;

export const getStoryboardFeature = ({ features }) => features.storyboardFeature;

export const getTermsOfUsageFeature = ({ features }) => features.termsOfUsageFeature;

export const getUserApiFeature = ({ features }) => features.userApiFeature;

export const getWatchAgainFeature = ({ features }) => features.watchAgainFeature;
